import React from "react";
import { connect } from "react-redux";
import { openModalDialog } from "../../redux/actions/report-actions";
import Page2Header from "./page2-header";
import Graph12Leads from "./graph-12leads";
import GraphRhythm from "./graph-rhythm";
import "./report-page2.scss";
import Localized from "../localized";
import { chooseCmpx_dialog } from "../popup-dialog-manager/constants";
import { modal_mode_halfscreen } from "../../redux/actions/actionConstants";

const ReportPage2 = props => {
    const { report, openModalDialog, editMode, halfPopup } = props;
    if (!report) {
        return null;
    }

    const popupable = editMode && !halfPopup;
    return (
        <div className="page page2">
            <Localized>
                <Page2Header />
                <Graph12Leads openDialog={() => openModalDialog(chooseCmpx_dialog)} popupable={popupable} />
                <GraphRhythm popupable={popupable} />
            </Localized>
        </div>
    );
};

const mapStateToProps = ({
    reportApp: {
        reportData: { report },
        app
    }
}) => {
    return {
        report,
        editMode: app.settings.editMode,
        halfPopup: app.modal.opened && app.modal.dialogMode === modal_mode_halfscreen
    };
};
const mapDispatchToProps = {
    openModalDialog
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportPage2);
